import objectFitImages from 'object-fit-images';

window.objectFitImages = objectFitImages;

objectFitImages('img.object-fit-images');
